module.exports = __webpack_public_path__ + "img/m_Paraiso.f2fc87da.png";